import { enum as affiliateRanks } from '../../../../../enums/affiliate-ranks';

const classNamePrefix = 'ranks-points-table';

const ranks = affiliateRanks.map((rank) => rank.name);

const columnSorting = {
	key: 'column',
	remote: false,
	direction: 'desc'
};

const table = [
	[
		{
			index: 'affiliate',
			header: {
				title: 'affiliate',
				description: 'affiliate',
				rowSpan: 3,
				sorting: columnSorting
			},
			column: {}
		},
		{
			index: 'rank',
			header: {
				title: 'rank',
				description: 'rank-at-end-of-curr-period',
				colSpan: 2
			}
		},
		{
			index: 'conversions',
			header: {
				title: 'conversions',
				description: 'conversions-in-curr-period',
				colSpan: 4
			}
		},
		{
			index: 'balance',
			header: {
				title: 'balance',
				description: 'balance',
				colSpan: 2
			}
		},
		{
			index: 'purchases',
			header: {
				title: 'purchases',
				description: 'purchases',
				colSpan: 12
			}
		}
	],
	[
		{
			index: 'rank.curr',
			header: {
				title: 'curr',
				description: 'curr-rank',
				rowSpan: 2,
				sorting: columnSorting
			},
			column: {
				format: v => ranks[v]
			}
		},
		{
			index: 'rank.prev',
			header: {
				title: 'prev',
				description: 'prev-rank',
				rowSpan: 2,
				sorting: columnSorting
			},
			column: {
				format: v => ranks[v]
			}
		},
		{
			index: 'conversions.total',
			header: {
				icon: `${classNamePrefix}-icon-total`,
				description: 'total-conversions',
				rowSpan: 2,
				sorting: columnSorting
			},
			column: {}
		},
		{
			index: 'conversions.approved',
			header: {
				icon: `${classNamePrefix}-icon-approved`,
				description: 'approved-conversions',
				rowSpan: 2,
				sorting: columnSorting
			},
			column: {}
		},
		{
			index: 'conversions.approvedPercent',
			header: {
				className: `${classNamePrefix}-icon-percent-head`,
				title: '%',
				description: 'percent-approved-total-conversions',
				rowSpan: 2,
				sorting: columnSorting
			},
			column: {
				format: v => v.toFixed(2)
			}
		},
		{
			index: 'conversions.redeemedPercent',
			header: {
				className: `${classNamePrefix}-icon-percent-head`,
				title: '%',
				description: 'percent-redeemed-approved-conversions',
				rowSpan: 2,
				sorting: columnSorting
			},
			column: {
				format: v => v.toFixed(2)
			}
		},
		{
			index: 'balance.curr',
			header: {
				title: 'curr',
				description: 'balance-at-end-of-curr-period',
				rowSpan: 2,
				sorting: columnSorting
			},
			column: {}
		},
		{
			index: 'balance.prev',
			header: {
				title: 'prev',
				description: 'balance-at-end-of-prev-period',
				rowSpan: 2,
				sorting: columnSorting
			},
			column: {}
		},
		{
			index: 'purchases.curr',
			header: {
				title: 'curr',
				description: 'purchases-in-curr-period',
				colSpan: 2
			}
		},
		{
			index: 'purchases.prev',
			header: {
				title: 'prev',
				description: 'purchases-in-prev-period',
				colSpan: 2
			}
		},
		{
			index: 'desiredGood',
			header: {
				title: 'desired good',
				description: 'desired-good-in-curr-period',
				colSpan: 2
			}
		}
	],
	[
		{
			index: 'purchases.curr.count',
			header: {
				title: 'count',
				description: 'purchases-count',
				sorting: columnSorting
			},
			column: {}
		},
		{
			index: 'purchases.curr.value',
			header: {
				title: 'value',
				description: 'purchases-value',
				sorting: columnSorting
			},
			column: {}
		},
		{
			index: 'purchases.prev.count',
			header: {
				title: 'count',
				description: 'purchases-count',
				sorting: columnSorting
			},
			column: {}
		},
		{
			index: 'purchases.prev.value',
			header: {
				title: 'value',
				description: 'purchases-value',
				sorting: columnSorting
			},
			column: {}
		},
		{
			index: 'desiredGood.title',
			header: {
				title: 'title',
				description: 'good-title',
				sorting: columnSorting
			},
			column: {}
		},
		{
			index: 'desiredGood.price',
			header: {
				title: 'price',
				description: 'good-price',
				sorting: columnSorting
			},
			column: {}
		}
	]
];

const sortedBy = {
	column: {
		index: 'affiliate',
		direction: 'asc'
	}
};

export default {
	table,
	sortedBy
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/ranks-points-report/table-initial-data.js